﻿import { events } from "@grindex-common/helpers/events";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";
import { apiConfig } from "@grindex-common/helpers/apiConfig";
import DocumentsApiBase from "./DocumentsApi.class";

(function listenForEvent() {
	asyncModule("tpiDocuments", events.tabLoadedEvent(new TabNames().product.documentation), init);
})();

function init($module) {
	const salesCode = $module.dataset.apiQuery;
	const brand = encodeURIComponent(window.config.brand.name);
	const language = apiConfig.apiLanguage;
	const apiUrl = `/${apiConfig.apiLanguage}/api/tpidocuments/search/?salesCode=${salesCode}&language=${language}&brand=${brand}`;
	const documentLoader = new DocumentsApiBase($module, apiUrl);

	documentLoader.run();
}

export default {
	view: "tpiDocuments",
	init,
};
